module.exports = __webpack_public_path__ + "img/Clock_Icon.60d2b349.svg";